import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { GradientButton } from "@/screens/_shared";

const UpgradeSuccess = () => {
    const navigate = useNavigate();
    return (
        <div className="screen items-center justify-center px-6 text-center" data-testid="premium-success-screen">
            <div
                aria-hidden
                className="pointer-events-none absolute inset-0"
                style={{
                    background:
                        "radial-gradient(500px 400px at 50% 35%, hsl(var(--primary) / 0.2), transparent 60%)",
                }}
            />
            <div className="relative z-10 flex flex-col items-center animate-fade-up">
                <span
                    className="h-20 w-20 rounded-full flex items-center justify-center text-primary-foreground shadow-card"
                    style={{
                        background:
                            "linear-gradient(135deg, hsl(var(--primary)), hsl(var(--primary) / 0.78))",
                    }}
                >
                    <CheckCircle2 size={36} strokeWidth={2.4} />
                </span>
                <h1 className="mt-5 font-display text-[22px] font-semibold">
                    You're Premium now
                </h1>
                <p className="mt-1.5 text-[13.5px] text-muted-foreground max-w-xs">
                    Insights unlocked, contact access on, and your profile gets priority ranking.
                </p>
                <div className="mt-8 w-full max-w-xs space-y-2">
                    <GradientButton
                        testId="premium-success-continue"
                        onClick={() => navigate("/profile", { replace: true })}
                    >
                        Go to Profile
                    </GradientButton>
                    <button
                        data-testid="premium-success-insights"
                        onClick={() => navigate("/insights", { replace: true })}
                        className="w-full h-12 rounded-2xl bg-secondary text-secondary-foreground font-medium text-[13.5px] active:scale-[0.98]"
                    >
                        Open Insights
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradeSuccess;
